export const CHANGE_LOCATION = "router/CHANGE_LOCATION";
